/**
 * Checks to see if any select state variables are set to the default value
 * @param stateVarList List of all state vaiables current value
 * @param defaultOptionsList List of all the default options
 * @returns Returns true if no select state variables are set to the default value
 */
export const validateSelect = (stateVarList: string[], defaultOptionsList: string[]): boolean =>
    !stateVarList.some(item => defaultOptionsList.includes(item));

/**
 * Checks to verify that all values are valid floats
 * @param valuesToValidate List of strings to validate
 * @returns Returns true if all strings are valid floats
 */
export const validateAllInputs = (valuesToValidate: string[]): boolean => !valuesToValidate.some(value => isNaN(parseFloat(value)));

/**
 * Checks to verify that the input string is a valid float or an empty string.
 * @param valueToValidate String to validate
 * @returns Returns true if the input is either a valid float or an empty string
 */
export const validateCurrentInput = (valueToValidate: string): boolean => {
    if (isNaN(parseFloat(valueToValidate))) {
        return valueToValidate === '';
    }
    return true;
};
